import {
  SliderPaginationBase,
  SliderPaginationBaseProps,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CoinsLevelsHeader: React.FC<
  {title?: string} & Omit<SliderPaginationBaseProps, 'theme'>
> = ({title, ...sliderProps}) => {
  return (
    <Header>
      {title && (
        <Text size="px16" weight="mediumHeavy">
          {title}
        </Text>
      )}
      <StyledSliderPaginationBase
        {...sliderProps}
        theme={{
          iconSize: 'XSS',
          borderColor: 'Outline.Grey',
          iconColorEnabled: 'Black',
          iconColorDisabled: 'Fill.Grey.Inactive',
        }}
      />
    </Header>
  );
};

const Header = styled.div`
  display: none;

  ${tabletAndUpLinaria(`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `)}
`;

const StyledSliderPaginationBase = styled(SliderPaginationBase)`
  &&& {
    margin: 0;
  }
`;
